module.exports = __webpack_public_path__ + "static/media/LV4@4x.6a2b7a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV4@4x.png
// module id = 685
// module chunks = 0